"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _message = _interopRequireDefault(require("./message.style"));

var _typeIcon = _interopRequireDefault(require("./type-icon/type-icon.component"));

var _messageContent = _interopRequireDefault(require("./message-content/message-content.component"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

var _icon = _interopRequireDefault(require("../icon"));

var _iconButton = _interopRequireDefault(require("../icon-button"));

var _utils = require("../../style/utils");

var _useLocale = _interopRequireDefault(require("../../hooks/__internal__/useLocale"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const Message = ({
  open = true,
  transparent = false,
  title,
  variant = "info",
  children,
  onDismiss,
  id,
  className,
  closeButtonAriaLabel,
  showCloseIcon = true,
  ...props
}) => {
  const marginProps = (0, _utils.filterStyledSystemMarginProps)(props);
  const l = (0, _useLocale.default)();

  const renderCloseIcon = () => {
    if (!showCloseIcon || !onDismiss) return null;
    return /*#__PURE__*/_react.default.createElement(_iconButton.default, {
      "data-element": "close",
      "aria-label": closeButtonAriaLabel || l.message.closeButtonAriaLabel(),
      onAction: onDismiss,
      variant: variant
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "close"
    }));
  };

  return open && /*#__PURE__*/_react.default.createElement(_message.default, _extends({}, (0, _tags.default)("Message", props), {
    className: className,
    transparent: transparent,
    variant: variant,
    role: "status",
    id: id
  }, marginProps), /*#__PURE__*/_react.default.createElement(_typeIcon.default, {
    variant: variant,
    transparent: transparent
  }), /*#__PURE__*/_react.default.createElement(_messageContent.default, {
    variant: variant,
    transparent: transparent,
    title: title
  }, children), renderCloseIcon());
};

Message.propTypes = { ...marginPropTypes,

  /** set type of message based on new DLS standard */
  variant: _propTypes.default.oneOf(["default", "error", "help", "info", "maintenance", "new", "success", "warning"]),

  /** set content to component */
  children: _propTypes.default.node,

  /** set custom class to component */
  className: _propTypes.default.string,

  /** set custom id to component root */
  id: _propTypes.default.string,

  /** show message component */
  open: _propTypes.default.bool,

  /** function runs when user click dismiss button */
  onDismiss: _propTypes.default.func,

  /** set message title */
  title: _propTypes.default.node,

  /** set background to be invisible */
  transparent: _propTypes.default.bool,

  /** determines if the close icon is shown */
  showCloseIcon: _propTypes.default.bool,

  /** set custom aria label for message close button */
  closeButtonAriaLabel: _propTypes.default.string
};
var _default = Message;
exports.default = _default;